export default "__VITE_ASSET__wUBHSZXz__"